import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";

var Onlineshow = /*#__PURE__*/function () {
  function Onlineshow(context) {
    _classCallCheck(this, Onlineshow);

    this.context = context;
  }

  _createClass(Onlineshow, [{
    key: "getAll",
    value: function getAll(params) {
      return this.context.http.get('/msvc/v1/onlineshows/items', params);
    }
  }, {
    key: "get",
    value: function get(id) {
      return this.context.http.get("/msvc/v1/onlineshows/items/".concat(id));
    }
  }, {
    key: "getOnlineShowViews",
    value: function getOnlineShowViews(id) {
      return this.context.http.get("/msvc/v1/onlineshows/views/".concat(id));
    }
  }, {
    key: "put",
    value: function put(id, params) {
      return this.context.http.put("/msvc/v1/onlineshows/items/".concat(id), params);
    }
  }, {
    key: "post",
    value: function post(params) {
      return this.context.http.post('/msvc/v1/onlineshows/items', params);
    }
  }, {
    key: "del",
    value: function del(id) {
      return this.context.http.del("/msvc/v1/onlineshows/items/".concat(id));
    }
  }, {
    key: "getTemporaryToken",
    value: function getTemporaryToken() {
      return this.context.http.post('/msvc/v1/qrcode/artworks/token');
    }
  }]);

  return Onlineshow;
}();

export default Onlineshow;